export default {
  // totalFlow
  volumeFlowRate: 'Vol. Flow Rate (MCF)',
  todayVolume: 'Today\'s Volume (MCF)',
  yesterdayVolume: 'Yesterday\'s Volume (MCF)',
  accumulatedVolume: 'Accumulated Volume (MCF)',
  lastCalcPeriodVolume: 'Last Calc. Period Vol. (MCF)',
  diffPressure: 'Diff. Pressure (" H20)',
  staticPressure: 'Static Pressure (PSIA)',
  battery: 'Battery (Volts)',
  charger: 'Charger (Volts)',
  energyRate: 'Energy Rate (MBTU/HR)',
  todayEnergy: 'Today\'s Energy (MBTU)',
  yesterdayEnergy: 'Yesterday\'s Energy (MBTU)',
  temperature: 'Temperature (F)',
  temperatureDelta: 'Temperature Delta',
  volCalcPeriod: 'Volume Calc. Period (Seconds)',
  // tanks
  topLevel: 'Top Level (bbls)',
  topLevelDelta: 'Top Level Delta',
  oilLevel: 'Oil Level (bbls)',
  waterLevelDelta: 'Water Level Delta',
  waterLevel: 'Water Level (bbls)',
  voltage: 'Voltage',
  voltageDelta: 'Voltage Delta',
  highLevel: 'High Level',
  highLevelDelta: 'High Level Delta',
  criticalLevel: 'Critical Level',
  criticalLevelDelta: 'Critical Level Delta',
  rapidDecrease: 'Rapid Decrease',
  rapidDecreaseDelta: 'Rapid Decrease Delta',
  rapidIncrease: 'Rapid Increase',
  rapidIncreaseDelta: 'Rapid Increase Delta',
  correctionFactor: 'Correction Factor',
  correctionFactorDelta: 'Correction Factor Delta',
  sizeInInches: 'Size in Inches',
  sizeInInchesDelta: 'Size in Inches Delta',
  inchesToBarrels: 'Barrel Inches',
  inchesToBarrelsDelta: 'Inches to Barrels Delta'
};
